import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router/public_api';
import { CommonService } from '../../../app/_services/common.service';
import { appService } from '../../../app/_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { Helpers } from '../../../app/helpers';

declare var $: any;

@Component({
    selector: 'app-onfly-network',
    templateUrl: './onfly-network.component.html'
})

export class OnflyNetworkComponent implements OnInit {
    static that: OnflyNetworkComponent;
    TenantId: any;
    CompanyId: any;
    Company: any = {};
    OfficialAddress: any = {};
    Data: any = {};
    CompanyType: any = [];
    AccountData: any = {};
    hostUrl: any = environment.apiUrl;
    constructor(
        private _appService: appService,
        private toastr: ToastrService,
        private cookieservice: CookieService,
        private commonService: CommonService,
        private cookieService: CookieService
    ) {
        OnflyNetworkComponent.that = this;
    }

    ngOnInit() {
        this.CompanyId = JSON.parse(localStorage.getItem('ChnageCompnayId')).Id;
        this.TenantId = JSON.parse(localStorage.getItem('ChnageCompnayId')).TenantId;
        this.GetSelectData();
        this.GetCompanyType();
    }
    GetCompanyType() {
        this._appService.GetById("Common", "GetLookByCategoryName", "CompanyType").subscribe(response => {
            this.CompanyType = response;
            setTimeout(() => {
                (<any>$("#OnFlyNetworkType")).selectpicker("refresh");
            }, 150);
        }, err => {
            this.toastr.error("Error occurred while fetching Company Type Data !", 'error');
        });
    }

    GetSelectData() {
        $("#OnflyNetworkAccountsType").select2({
            width: "100%",
            escapeMarkup: function (markup) { return markup; },
            minimumInputLength: 2,
            ajax: {
                global: false,
                url: environment.apiUrl + "api/ChartsofAccount/GetAccountListforNetwork",
                delay: 300,
                dataType: 'json',
                allowClear: true,
                data: function (params) {
                    return {
                        query: params.term,
                        page: params.page || 1,
                    };
                },
                processResults: function (data, params) {
                    params.page = params.page || 1;
                    return {
                        results: data.Results,
                        pagination: {
                            more: (params.page * 30) < data.Total
                        }
                    };
                },
            },
            tokenSeparators: [',', ' '],

            placeholder: 'Enter Account'
        });
        $("#NCompanyCountry").select2({
            width: "100%",
            escapeMarkup: function (markup) { return markup; },
            minimumInputLength: 2,
            ajax: {
                global: false,
                url: environment.apiUrl + "api/Company/GetCountryWiseList",
                delay: 300,
                dataType: 'json',
                allowClear: true,
                data: function (params) {
                    $("#NCompanyCountry").text('');
                    return {
                        query: params.term,
                        page: params.page || 1,
                        CategoryName: "Country",
                        ParentId: null
                    };
                },
                processResults: function (data, params) {
                    params.page = params.page || 1;
                    return {
                        results: data.Results,
                        pagination: {
                            more: (params.page * 30) < data.Total
                        }
                    };
                },
            },
            tokenSeparators: [',', ' '],

            placeholder: 'Search Country'
        });
        $("#NCompanyState").select2({
            width: "100%",
            escapeMarkup: function (markup) { return markup; },
            minimumInputLength: 2,
            ajax: {
                global: false,
                url: environment.apiUrl + "api/Company/GetCountryWiseList",
                delay: 300,
                dataType: 'json',
                allowClear: true,
                data: function (params) {
                    $("#NCompanyState").text('');
                    return {
                        query: params.term,
                        page: params.page || 1,
                        CategoryName: "State",
                        ParentId: $("#NCompanyCountry").val()
                    };
                },
                processResults: function (data, params) {
                    params.page = params.page || 1;
                    return {
                        results: data.Results,
                        pagination: {
                            more: (params.page * 30) < data.Total
                        }
                    };
                },
            },
            tokenSeparators: [',', ' '],

            placeholder: 'Search State'
        });
        $("#NCompanyCity").select2({
            width: "100%",
            escapeMarkup: function (markup) { return markup; },
            minimumInputLength: 2,
            ajax: {
                global: false,
                url: environment.apiUrl + "api/Company/GetCountryWiseList",
                delay: 300,
                dataType: 'json',
                allowClear: true,
                data: function (params) {
                    $("#NCompanyCity").text('');
                    return {
                        query: params.term,
                        page: params.page || 1,
                        CategoryName: "City",
                        ParentId: $("#NCompanyState").val()
                    };
                },
                processResults: function (data, params) {
                    params.page = params.page || 1;
                    return {
                        results: data.Results,
                        pagination: {
                            more: (params.page * 30) < data.Total
                        }
                    };
                },
            },
            tokenSeparators: [',', ' '],

            placeholder: 'Search  City'
        });
    }
    // : Promise<void> 

    SaveComapny() {
        return new Promise((resolve, reject) => {
            this.OfficialAddress.Country = $("#NCompanyCountry").val();
            this.OfficialAddress.State = $("#NCompanyState").val();
            this.OfficialAddress.City = $("#NCompanyCity").val();

            this.Data.Company = {};
            this.Data.OfficialAddress = {};
            this.Data.BillingAddress = {};

            this.Data.Company = this.Company;
            this.Data.Company.TenantId = this.TenantId;
            this.Data.Company.IsNetworkCompany = 1;
            this.Data.OfficialAddress = this.OfficialAddress;
            this.Data.BillingAddress = this.OfficialAddress;

            this._appService.Post("Company", "SaveCompanyOnfly", this.Data).subscribe(response => {
                this.Company.Id = response;
                this.toastr.success("Transporter Added Successfully !", 'Success');
                Helpers.setLoading(false);
                resolve(response);
            }, err => {
                Helpers.setLoading(false);
                // this.toastr.error("Error occurred while saving transporter Data !", 'error');
                reject("Error occured while saving transporter Data");
            });
        })
    }

    ValidateRequiredField() {
        var flag = true;

        if (!this.commonService.ValidateRequiredField($("#FullName"), 'Please Enter Full Name', 'after', '')) {
            flag = false;
        }
        if (!this.commonService.ValidateRequiredField($("#ShortName"), 'Please Enter Short Name', 'after', '')) {
            flag = false;
        }
        if (!this.commonService.ValidateRequiredField($("#OfficeAddress"), 'Please Enter Address', 'after', '')) {
            flag = false;
        }
        if (!this.commonService.ValidateRequiredField2($("#NCompanyCountry"), $("#FieldSetNCompanyCountry"), 'Please Select Country', 'after', '')) {
            flag = false;
        }
        if (!this.commonService.ValidateRequiredField2($("#NCompanyState"), $("#FieldSetNCompanyState"), 'Please Select State', 'after', '')) {
            flag = false;
        }
        if (!this.commonService.ValidateRequiredField2($("#NCompanyCity"), $("#FieldSetNCompanyCity"), 'Please Select City', 'after', '')) {
            flag = false;
        }
        if (!this.commonService.ValidateRequiredField($("#OfficePostalCode"), 'Please Enter Postal Code', 'after', '')) {
            flag = false;
        }
        if (!this.commonService.ValidateRequiredField($("#OfficialPhone"), 'Please Enter Phone', 'after', '')) {
            flag = false;
        }
        if (!this.commonService.ValidateRequiredField($("#OfficialEmail"), 'Please Enter Email', 'after', '')) {
            flag = false;
        } else {
            if (!this.commonService.CheckEmail($("#OfficialEmail"), 'after')) {
                flag = false;
            }
        }
        if (!this.commonService.ValidateRequiredField2($("#OnFlyNetworkType"), $("#FieldSetOnFlyNetworkType"), 'Please Enter Network Type', 'after', '')) {
            flag = false;
        }
        if ($("#OnFlyNetworkType option:selected").text().trim() != 'Self') {
            if (!this.commonService.ValidateRequiredField2($("#OnflyNetworkAccountsType"), $("#FieldSetOnflyNetworkAccountsType"), 'Please Select Account', 'after', '')) {
                flag = false;
            }
        }

        return flag;
    }
    ClearValidation() {
        this.commonService.ClearMessage($("#FullName"));
        this.commonService.ClearMessage($("#ShortName"));
        this.commonService.ClearMessage($("#OfficeAddress"));
        this.commonService.ClearMessage($("#NCompanyCountry"));
        this.commonService.ClearMessage($("#FieldSetNCompanyCountry"));
        this.commonService.ClearMessage($("#NCompanyState"));
        this.commonService.ClearMessage($("#FieldSetNCompanyState"));
        this.commonService.ClearMessage($("#NCompanyCity"));
        this.commonService.ClearMessage($("#FieldSetNCompanyCity"));
        this.commonService.ClearMessage($("#OfficePostalCode"));
        this.commonService.ClearMessage($("#OfficialPhone"));
        this.commonService.ClearMessage($("#OfficialEmail"));
        this.commonService.ClearMessage($("#OnFlyNetworkType"));
        this.commonService.ClearMessage($("#FieldSetOnFlyNetworkType"));
        this.commonService.ClearMessage($("#OnflyNetworkAccountsType"));
        this.commonService.ClearMessage($("#FieldSetOnflyNetworkAccountsType"));
    }


    SaveData() {
        return new Promise(async (resolve2, reject2) => {
            var flag = this.ValidateRequiredField();
            if (flag != false) {
                if ($("#OnFlyNetworkType option:selected").text().trim() != 'Self') {
                    this.AccountData.Name = $("#FullName").val();
                    this.AccountData.ParentId = $("#OnflyNetworkAccountsType").val();
                    this.AccountData.IsActive = true;
                    this.AccountData.AccountType = 2;
                    this.AccountData.CompanyId = this.CompanyId;
                    this.AccountData.TenantId = this.TenantId;
                    if (this.AccountData.ParentId != "") {
                        this._appService.GetByThreeId("ChartsofAccount", "CheckAccountExist", this.AccountData.Id, this.AccountData.Name, this.AccountData.ParentId).subscribe(async response => {
                            this._appService.Post("ChartsofAccount", "SaveAccount", this.AccountData).subscribe(async response => {
                                this.Company.AccountTypeId = $("#OnflyNetworkAccountsType").val();
                                this.Company.AccountId = response.Id;
                                this.AccountData.Id = this.Company.AccountId;
                                await this.SaveComapny();
                                // await this.AuthorizeNetwork();
                                resolve2("");
                            }, err => {
                                reject2("Error occurred while saving data");
                            });
                        }, async err => {
                            this.Company.AccountTypeId = $("#OnflyNetworkAccountsType").val();
                            await this.SaveComapny();
                            // await this.AuthorizeNetwork();
                        });
                    }
                    else {
                        this.Company.AccountTypeId = $("#OnflyNetworkAccountsType").val();;
                        await this.SaveComapny();
                        // await this.AuthorizeNetwork();
                        resolve2("error");
                    }
                } else {
                    await this.SaveComapny();
                    resolve2("error");
                }
            } else {
                $("#SaveOnflyTransporter").prop('disabled', false);
                reject2("Please Fill Required Fields !");
            }
        });
    }

    ClearData() {
        this.Company = {};
        this.OfficialAddress = {};
        this.Data = {};
        $("#NCompanyCountry").val("");
        $('#NCompanyCountry').select2('destroy');
        $("#NCompanyState").val("");
        $('#NCompanyState').select2('destroy');
        $("#NCompanyCity").val("");
        $('#NCompanyCity').select2('destroy');
        $("#OnflyNetworkAccountsType").val("");
        $('#OnflyNetworkAccountsType').select2('destroy');
        this.GetSelectData();
        setTimeout(() => {
            (<any>$("#OnFlyNetworkType")).selectpicker("refresh");
        }, 150);
        this.ClearValidation();
    }

    //-------------------------Authorize------------------------
    AuthorizeNetwork() {
        return new Promise(async (resolve3, reject3) => {
            this._appService.GetByThreeId("Common", "AuthorizeTransaction", 6, this.Company.Id, this.CompanyId).subscribe(response => {
                this.toastr.success("Network Authorized Successfully !", 'Success');
                resolve3(response);
            }, err => {
                reject3("Error occured while authorizing network !")
            });
        })
    }

}
